import { render } from "./twocolumn.vue?vue&type=template&id=54beff6a"
import script from "./twocolumn.vue?vue&type=script&lang=js"
export * from "./twocolumn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/oscar/Desarrollo/Vue.js/FastWay/FastWayPro.005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__